module.exports = __webpack_public_path__ + "static/img/anxun51.14d90199.png";